import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';

export default function AddAGrappleMiniPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Breadcrumb */}
      <section className="bg-gray-100 py-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-2 text-sm">
            <Link to="/" className="text-[#dc3545] hover:underline">HOME</Link>
            <span>/</span>
            <span className="text-gray-600">ADD-A-GRAPPLE MINI</span>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left Column - Images and Video */}
          <div className="space-y-6">
            <div className="bg-white rounded-lg overflow-hidden shadow-md">
              <img
                              src="/images/AAGM_01.jpg"
                alt="Add A Grapple Mini"
                className="w-full h-auto"
              />
            </div>
            <div className="bg-white rounded-lg overflow-hidden shadow-md">
              
            </div>
          </div>

          {/* Right Column - Product Info */}
          <div className="bg-white rounded-lg p-8 shadow-md">
            
            <h1 className="text-3xl font-bold text-[#333333] mb-4">ADD-A-GRAPPLE MINI</h1>
            <h4 className="text-lg text-[#666666] mb-2">Model: 111155</h4>
            <h4 className="text-lg text-[#666666] mb-6">Weight: 125 lbs</h4>

            <h2 className="text-2xl font-bold text-[#333333] mb-4">
              Easily Convert Your Bucket Into a Grapple Bucket, 28″ Opening!
            </h2>

            <div className="space-y-4 text-[#666666] mb-6">
              <p>
                Introducing the versatile Add A Grapple Mini, designed as a grapple add-on for compact tractors and mini skid steers. This attachment converts existing buckets 36″ to 55″ in width into efficient grapple buckets, making it ideal for handling various materials. Weighing only 125 lbs, it's especially suitable for compact tractors with pinned buckets and mini skid steers. The grapple is easy to remove, allowing quick conversion back to a standard bucket while the mount stays securely in place.
              </p>
              <p>
                Each Add A Grapple Mini includes a robust design with curved teeth that provide a wider grip and smooth release of material. Refer to our Grapple Spec Sheet and Add A Grapple Selector below to ensure you choose the correct Add A Grapple for your bucket.
              </p>
              <p>
                All pivot points are greased for long-lasting performance, ensuring smooth and efficient operation even in demanding conditions. This
                
                  skid steer grapple attachment
               
                is an excellent addition for those looking to enhance their bucket's capabilities without a permanent modification.
              </p>
              <p>See our Grapple Spec Sheet and Add A Grapple Selector below to choose the correct Add A Grapple for your bucket</p>
            </div>

            <hr className="my-6" />

            {/* Features Accordion */}
            <div className="mb-6">
              <details className="group" open>
                <summary className="flex justify-between items-center cursor-pointer list-none font-bold text-lg text-[#333333] py-3 border-b">
                  FEATURES
                  <i className="ri-arrow-down-s-line text-2xl group-open:rotate-180 transition-transform"></i>
                </summary>
                <ul className="mt-4 space-y-2 text-[#666666] list-disc list-inside">
                  <li>28″ Grapple Opening, Fits Buckets 36″ to 55″ in Width</li>
                  <li>Fits Buckets 36″ to 55″ in Width</li>
                  <li>Curved Teeth for Wider Grip and Easy Release of Material</li>
                  <li>Grapple Can Be Removed to Convert Back to Bucket Only</li>
                </ul>
              </details>
            </div>

            {/* CTA Buttons */}
            <div className="space-y-4">
              <a
                href="/contact"
                className="block w-full bg-[#dc3545] hover:bg-[#c82333] text-white text-center py-3 px-6 font-bold rounded transition-colors"
              >
                Call Us Now
              </a>
              
              
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="mt-12 bg-white rounded-lg p-8 shadow-md">
          <h3 className="text-2xl font-bold text-[#333333] mb-6">FREQUENTLY ASKED QUESTIONS</h3>
          <div className="space-y-6 text-[#666666]">
            <div>
              <p className="font-bold text-[#333333] mb-2">
                Q: Can the Add A Grapple Mini be used as a skid steer grapple attachment?
              </p>
              <p className="mb-2">
                <strong>A:</strong> Yes, the Add A Grapple Mini is designed to work as a skid steer grapple attachment, making it easy to convert your existing bucket into a versatile grapple bucket. It's compatible with mini skid steers and compact tractors:
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>fitting buckets that are 36″ to 55″ wide</li>
                <li>provides a secure grip for handling various materials</li>
              </ul>
            </div>
            <div>
              <p className="font-bold text-[#333333] mb-2">
                Q: How easy is it to install the Add A Grapple as a grapple add-on for my tractor bucket?
              </p>
              <p>
                <strong>A:</strong> The Add A Grapple Mini is designed for easy installation as a grapple add-on. It securely mounts to your existing bucket and can be quickly removed when not needed. This means you can easily switch between using it as a grapple bucket for your tractor or reverting back to a standard bucket without hassle.
              </p>
            </div>
            <div>
              <p className="font-bold text-[#333333] mb-2">
                Q: What types of tasks can the Add A Grapple Mini handle as a grapple bucket for tractors?
              </p>
              <p className="mb-2">
                <strong>A:</strong> The Add A Grapple Mini is perfect for handling a wide range of tasks, including:
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>moving debris, brush, and other loose materials</li>
                <li>small-scale farming</li>
                <li>landscaping</li>
                <li>cleanup operations</li>
              </ul>
            </div>
          </div>
        </div>

        

        {/* Disclaimer */}
        <div className="mt-12 bg-white rounded-lg p-8 shadow-md text-center">
          <h3 className="text-xl font-bold text-[#dc3545] mb-4">SOLVING TREE & BRUSH PROBLEMS SINCE 1992!</h3>
          <p className="text-[#666666]">
            All products have been carefully manufactured and tested. Should our product prove defective, or appear to be, please discontinue use immediately and contact us. Not responsible for any damage or claims beyond the selling price of the product. No returns allowed without express written consent of company.
          </p>
        </div>
      </div>

    
    </div>
  );
}
